import { createElement, forwardRef } from 'react';
import { hstack } from '../patterns/hstack.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const HStack = /* @__PURE__ */ forwardRef(function HStack(props, ref) {
  const [patternProps, restProps] = splitProps(props, hstack.propKeys)
  const styleProps = hstack.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})